/**
 *
 * @desc 微前端-主应用
 * @author zhuzj
 *
 */
import React from "./react.shim";
import {GlobalContext} from './GlobalContext';

function getTnsSystem(){
    if(window.tnsSdk) {
        return window.tnsSdk.getMicroSystem();
    } else {
        throw new Error (`[TNE]小应用异常: tnsSdk.js未加载`);
    }
}

// 累计主应用实例对象创建数
let MAIN_APP_GLOBAL_OID = 0;


// -------- PurpComponent 内部默认实现的对象比较函数 -----------begin
function is(x, y) { // 低版本浏览器兼容实现
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = typeof Object.is === 'function' ? Object.is : is;

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) { //比较引用关系
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) { //比较key数量变化
        return false;
    }


    for (var i = 0; i < keysA.length; i++) { //比较第一层key的值
        if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }

    return true;
}
// -------- PurpComponent 内部默认实现的对象比较函数 -----------end

class MainApplication extends React.Component{
    static defaultProps = {
        providerHost:null,
        providerName:null,
        providerEntry:null,
        providerMode:'react', //react|class
        routePath:null,
        onSuccess:null,
        onError:null,
    }
    constructor(props){
        super(props);
        //当前组件对象OID
        MAIN_APP_GLOBAL_OID++;
        this.oid = MAIN_APP_GLOBAL_OID;
        this.state = {
            load:0,//0 未加载、1 加载中、2 加载完成、-1 加载失败
            SmallAppView:null
        }
        this.smallAppClass = null;
    }

    loadSmallApp=(props)=>{
        const tnsSys = getTnsSystem();
        // const loadConfig = {
        //     // providerHost:"/iuap-tns/ucf-wh/front-engine/nginx-manager/",
        //     providerHost: "https://developer-test.yyuap.com/iuap-tns/ucf-wh/front-engine/",
        //     // providerHost:"http://local.yyuap.com:3000",
        //     providerName: "frontEngine",
        //     providerEntry: "MicroDebugPage",
        // }
        const loadConfig ={
            providerHost:props.providerHost,
            providerName:props.providerName,
            providerEntry:props.providerEntry,
            // 判断TNS小应用入口加载是否走CDN加载
            isSmallAppEntryCdn:props.isSmallAppEntryCdn,
        }
        this.setState({load:1});
        tnsSys.loadComponent(Object.assign({
            onSuccess:(Module)=>{
                // console.log("BBB--->222",Module);
                console.log(`[TNE]小应用加载成功: ${loadConfig.providerName}!${loadConfig.providerEntry}`)
                if(this.props.providerMode==='class'){
                    let appContextValues = this.getAppContextValues();
                    this.smallAppClass = new Module(appContextValues);
                }
                this.setState({load:2,SmallAppView:Module},()=>{
                    if(this.props.providerMode==='class') {
                        if (this.smallAppClass && typeof this.smallAppClass.onStartup == 'function') {
                            this.smallAppClass.onStartup();
                        } else {
                            console.error(`[TNE]小应用未定义class 或 onStartup 方法，请定义标准入口，参考如下: 
                    export default class MySmallApplication{
                        constructor(appContext){
                            this.appContext = appContext;
                        }
                        onStartup(){
                           console.log("小应用启动容器ID："+this.appContext.currContainerId)  
                        }
                        onShutdown(){
                           console.log("小应用关闭容器ID："+this.appContext.currContainerId)  
                        }
                    }
                    `);
                        }
                    }
                    props.onSuccess && props.onSuccess();
                })
            },
            onError:(err)=>{
                this.setState({load:-1});
                console.error(`[TNE]小应用加载异常: ${loadConfig.providerName}!${loadConfig.providerEntry}，请对应业务服务检查以下错误信息`)
                console.error(err)
                props.onError && props.onError();
            }
        },loadConfig));
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {providerName,providerEntry} = this.props;
        const prevUrl = providerName+"!"+providerEntry;
        const nextUrl = nextProps.providerName+"!"+nextProps.providerEntry
        if(prevUrl!== nextUrl){
            this.loadSmallApp(nextProps);
        }
    }

    // 优化渲染，属性、状态、工作台数据未变化则不触发渲染，例如：工作台切换页签时不触发重新渲染。
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const getPropsJson = function (attrs){
            let {onError,onSuccess,...otherAttrs} = attrs; //排除不参与比较的属性
            let jsonStr = JSON.stringify(otherAttrs);
            return jsonStr;
        };
        let oldPropsJson = getPropsJson(this.props);
        let newPropsJson = getPropsJson(nextProps);
        let oldDiworkData = this.props.diworkData?JSON.stringify(this.props.diworkData):null;
        let newDiworkData = nextProps.diworkData?JSON.stringify(nextProps.diworkData):null;

        // console.log("TNS--->!(oldPropsJson===newPropsJson)",(oldPropsJson===newPropsJson))
        // console.log("TNS--->!(oldDiworkData===newDiworkData)",(oldPropsJson===newPropsJson))

        let shouldUpdate = (
            !shallowEqual(this.state, nextState) || //比较状态第一层是否变化
            !(oldPropsJson===newPropsJson) || //比较属性是否变化
            !(oldDiworkData===newDiworkData)   //比较diworkData是否变化
        );
        return shouldUpdate;
    }

    componentDidMount() {
        this.loadSmallApp(this.props);
    }

    componentDidCatch(error, errorInfo) {
        const {onError, providerName, providerEntry} = this.props;
        if(onError){
            onError(error,errorInfo);
        }else{
            console.log(`[TNE]小应用渲染异常: ${providerName}!${providerEntry}，请对应业务服务检查以下错误信息`);
            console.error(error,errorInfo);
        }
    }

    componentWillUnmount() {
        this.smallAppClass && this.smallAppClass.onShutdown && this.smallAppClass.onShutdown();
    }

    getAppContextValues=()=>{
        const {providerHost, providerName, providerEntry,providerMode,routePath,routeParam,onSuccess,onError,...otherProps} = this.props;
        const appContextValues = Object.assign({
            currProviderOID:this.oid,
            currProviderHost:providerHost,
            currProviderName:providerName,
            currProviderEntry:providerEntry,
            currProviderMode:providerMode,
            currContainerId:providerName+"_"+providerEntry,
            currRouterName:providerName+"!"+providerEntry,
            currRoutePath:routePath,
            currRouteParam:routeParam,
        },otherProps);// 将其它自定义属性传递给子应用
        return appContextValues;
    }

    render() {
        const {providerHost, providerName, providerEntry,providerMode,routePath,routeParam,...otherProps} = this.props;
        const {load,SmallAppView} = this.state;
        const appContextValues = this.getAppContextValues();// 将其它自定义属性传递给子应用
        if(!providerName || !providerEntry){
            return <div>小应用运行终止，缺少必要属性：providerName、providerEntry</div>;
        }
        if(load===0){ // 未加载
            return <div>no small app run!</div>
        }else if(load===1){ // 加载中
            return null
        }else if(load===2){ // 加载完
            if(SmallAppView){
                console.log(`[TNE]小应用开始渲染: ${providerName}!${providerEntry}`);
                if(providerMode==='class'){
                    return <div id={appContextValues.currContainerId} className={providerName} style={{width:'100%',height:'100%',position:'relative'}} tinper-next-role="container"></div>
                }else{
                    return <GlobalContext.Provider value={appContextValues}>
                        <React.Suspense fallback={null}>
                            {/*<LazyComponent/>*/}
                            {/*<HashRouter basename={providerName}>*/}
                            {/*<Switch>*/}
                            <SmallAppView/>
                            {/*</Switch>*/}
                            {/*</HashRouter>*/}
                        </React.Suspense>
                    </GlobalContext.Provider>
                }
            }else{
                return <div>小应用不存在,F12打开控制台查看异常日志</div>;
            }
        }else{ //加载失败
            return <div>小应用加载失败,F12打开控制台查看异常日志</div>
        }
    }
}
// 从url解析配置信息
MainApplication.parseUrl = function(url){
    return getTnsSystem().parseLoadConfig(url);
}

export default MainApplication;
//
// // 微前端应用系统的运行入口
// function runMicroSystem(options){
//     const {appContainerId,appCode,providerEntry,appHost,onReady,onError,dynamicVersion=true} = options;
//     if(!appContainerId||!appCode||!providerEntry){
//         console.error(`[TNE]缺少必要参数：appContainerId,appCode,providerEntry`);
//         return;
//     }
//     const appContainer = document.getElementById(appContainerId);
//     if(!appContainer){
//         console.error(`[TNE]document.getElementById('${appContainerId}')找不到元素`);
//         return;
//     }
//     let appHostUrl = `/${appCode}.js`;
//     if(appHost){
//         if(appHost.endsWith('.js')) { //例如："https://bip-daily.yyuap.com/iuap-xxx/app.js" 或 "/iuap-xxx/app.js"
//             appHostUrl = appHost;
//         }else if(appHost.endsWith('/')) { //例如："https://bip-daily.yyuap.com/iuap-xxx/" 或 "/iuap-xxx/"
//             appHostUrl = appHost+`${appCode}.js`;
//         }else{// 例如："https://bip-daily.yyuap.com/iuap-xxx" 或 "/iuap-xxx"
//             appHostUrl = appHost+`/${appCode}.js`;
//         }
//     }
//     if(dynamicVersion){
//         appHostUrl=appHostUrl+'?t='+(new Date().getTime());
//     }
//     try{
//         ReactDOM.render( <MicroSystem url={appHostUrl} scope={appCode} module={providerEntry} onReady={onReady} onError={onError}/>, appContainer);
//     }catch(e){
//         console.log('[TNE]微前端应用运行异常:',e);
//         appContainer.innerText = '[TNE]微前端应用运行异常，F12打开控制台查看异常日志';
//     }
// }

